<template>
    <div>
        <div style="">
            <Wp_nav_bar v-if="showNavBar" title="订单"></Wp_nav_bar>

            <Wp_time_pick_model date-format="yyyy-MM-dd"
                                :top="timeModelTop"
                                @pickTimes="pickTimes"
                                @search="clickToSearch"
            ></Wp_time_pick_model>

        </div>

        <div v-if="orderList">
            <!--            <div style="margin-left: 3%; margin-right: 3%; width: 94%; height: 1px; background-color: #dddddd"></div>-->
            <div>
                <div style="margin-left: 15px; font-size: 12px; color: red; padding-top: 10px">
                    *未付款订单数据无法查询<br/>
                </div>
            </div>

            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="已获取全部数据~"
                    @load="onLoad"
            >
                <Wp_pdd_order_list :orderList="orderList"></Wp_pdd_order_list>
            </van-list>
        </div>


    </div>
</template>

<script>
    import Wp_time_pick_model from "../../custom/Wp_time_pick_model";
    import {Toast} from "vant";
    import Wp_nav_bar from "../../custom/Wp_nav_bar";
    import Wp_pdd_order_list from "../pages_childs/Wp_pdd_order_list";
    export default {
        name: "Wp_pdd_order_page",
        components: {Wp_pdd_order_list, Wp_nav_bar, Wp_time_pick_model},
        props:{
            timeModelTop:{type: Number, defaule: 0}
        },
        data() {
            return {
                //collapse绑定的name，为空时，面板关闭
                // activeNames: ['1'],

                currentDate: new Date(),
                minDate: new Date('2019', '00', '01'),
                maxDate: new Date(),
                // start_time: '',
                // end_time: '',

                pickType: 'start',

                startTime: '',
                endTime: '',
                show: false,

                left_text: "时间",
                center_text: "到",

                //展示的开始时间，用于van-field绑定的model
                start_time_model: '',
                //展示的结束时间，用于van-field绑定的model
                end_time_model: '',

                orderList: [],
                pid: this.$common.getPid(),
                // pid: '1834339578',

                //上拉加载状态结束
                loading: false,
                //数据全部加载完成的状态
                finished: false,
                //请求数据页码
                page_index: 1,
                //一次页面请求多少数据
                page_size: 20,
                //展开面板右侧图标位置的文字内容
                // collapse_righe_icon: '收起',


                showNavBar: false,
            }
        },

        created() {
            // this.initTimes();
            if(this.$route.query.from && this.$route.query.from === 'tb_select'){
                this.showNavBar = true;
            }
        },

        methods: {

            /**
             * 选择时间
             * @param value 回调传入的选择的时间
             */
            pickTimes(times) {
                this.$log("--------------")
                this.$log("times = " + times)
                this.startTime = times.start_time;
                this.endTime = times.end_time;
                // if (this.pickType === 'start') {
                //     this.startTime = this.$common.dateFmt("yyyy-MM-dd 00:00:00", value);
                //     this.start_time_model = this.$common.dateFmt("yyyy-MM-dd", value);
                //     this.show = false;
                // } else if (this.pickType === 'end') {
                //     let endDate = new Date(value.getTime() + 24 * 60 * 60 * 1000 - 1);
                //     this.endTime = this.$common.dateFmt("yyyy-MM-dd hh:mm:ss", endDate);
                //     this.end_time_model = this.$common.dateFmt("yyyy-MM-dd", endDate);
                //     this.show = false;
                // }
            },


            /**
             * 上拉加载
             */
            onLoad() {
                // 异步更新数据
                setTimeout(() => {
                    this.getOrderList(datas => {
                        this.loadDatas(datas);
                        //关闭collapse面板
                        // this.activeNames = [];
                    });

                }, 2000);
            },

            loadDatas(datas) {
                if (datas) {
                    //list一次加载的数据
                    let limit = this.page_size;
                    //如果总数据数组的length小于没次加载的限制值，则直接使用数组length
                    if (datas.length < limit) {
                        limit = datas.length;
                        //如果一次获取到的数据，小于限制的数值，则表示数据已全部获取完成
                        this.finished = true;
                    } else {
                        this.finished = false;
                    }

                    for (let i = 0; i < limit; i++) {
                        this.orderList.push(datas[i]);
                    }

                    // 加载状态结束
                    this.loading = false;

                    this.page_index += 1;
                } else {
                    // 加载状态结束
                    this.loading = false;
                    // 获取数据结束
                    this.finished = true;
                }
                //关闭下拉刷新
                this.isLoading = false;
            },

            /**
             * 获取商品总数量
             */
            getTotalGoodsNum(data) {
                if (data && data.skuList && data.skuList.length > 0) {
                    let totalGoodsNum = 0;
                    for (let i = 0; i < data.skuList.length; i++) {
                        totalGoodsNum += Number(data.skuList[i].skuNum);
                    }
                    return totalGoodsNum;
                }
                return 0;
            },

            /**
             * 获取总支付金额
             */
            getTotalAmount(data) {
                if (data && data.skuList && data.skuList.length > 0) {
                    let totalAmount = 0;
                    for (let i = 0; i < data.skuList.length; i++) {
                        //如果是"已完成"（17），则总支付金额，直接使用"实际计佣金额"，否则使用"预估佣金"
                        if (this.isFinish(data) && data.skuList[i].actualCosPrice > 0) {
                            totalAmount += data.skuList[i].actualCosPrice;
                        } else {
                            totalAmount += data.skuList[i].estimateCosPrice;
                        }
                    }
                    return totalAmount;
                }
                return 0;
            },

            /**
             * 获取总预估佣金(若是"已完成"状态，则使用"实际佣金"值)
             */
            getTotalEstimateFee(data) {
                if (data && data.skuList && data.skuList.length > 0) {
                    let totalEstimateFee = 0;
                    for (let i = 0; i < data.skuList.length; i++) {
                        //实际佣金比例（佣金比例 * 最终比例）除以2，平分
                        // let commissionRate = (data.skuList[i].commissionRate / 100) * (data.skuList[i].finalRate / 100) / 2;
                        let commissionRate = (data.skuList[i].commissionRate / 100) * (data.skuList[i].finalRate / 100) * this.$common.commissionRate_pir;
                        //如果是"已完成"（17），则总预估佣金，直接使用"实际佣金"，否则使用"预估佣金"
                        if (this.isFinish(data) && data.skuList[i].actualFee > 0) {
                            // totalEstimateFee += data.skuList[i].actualFee;
                            totalEstimateFee += data.skuList[i].actualCosPrice * commissionRate;
                        } else {
                            // totalEstimateFee += data.skuList[i].estimateFee;
                            totalEstimateFee += data.skuList[i].estimateCosPrice * commissionRate;
                        }
                    }
                    return totalEstimateFee.toFixed(2);
                }
                return 0;
            },


            /**
             * 判断是否是"已完成"（17）状态
             * @return {boolean}
             */
            isFinish(data) {
                if (Number(data.validCode) === 17) {
                    return true;
                } else {
                    return false;
                }
            },

            /**
             * 根据选择的时间查询数据
             */
            clickToSearch() {
                if(this.loading){
                    this.$toast("数据查询中，请稍后...")
                }else{
                    this.orderList = [];
                    this.page_index = 1;

                    this.finished =false;
                    this.loading = true;
                    this.onLoad();
                }
            },

            /**
             * 获取订单列表数据
             */
            getOrderList(fn){
                let params = this.getBaseParams();
                // this.$getOrderByFinish_pdd(params, response=>{
                this.$getOrderList_pdd(params, response=>{
                    this.$log(response)
                    if(response && response.code === 200){
                        // this.order_list = response.data;
                        if(response.data){
                            if (fn) {
                                fn(response.data);
                            }

                        }else if(response.toString().indexOf("Error: timeout") != -1){
                            if (fn) {
                                fn(null);
                            }
                            this.$dialog.alert({
                                message: "数据加载超时，请重试"
                            })
                        }
                    }else{
                        if (fn) {
                            fn(null);
                        }
                        // Toast.fail({
                        //     message: '数据为空' + response.code
                        // })
                    }
                })
            },

            /**
             * 获取基础参数
             */
            getBaseParams() {
                // pid:推荐位ID
                // orderid:订单号
                // skuname:商品名称
                // vcode:状态 默认所有 3：订单结算，12：订单付款， 13：订单失效，14：订单成功
                // stime:开始时间 默认当天
                // etime:结束时间  默认当天
                // page:第几页
                // size:每页显示纪录数
                let params = {
                    pid: this.$common_pdd.getPddPid(),//2423136353
                    // pid: '2423136353',//2423136353
                    // pid:'',
                    orderid: '',
                    skuname: '',
                    vcode: '',
                    stime: this.startTime,
                    etime: this.endTime,
                    page: this.page_index,
                    size: this.page_size,
                    sort: 'desc',
                };
                // if(this.$common.gloabl_wx_mini_user_info && this.$common.gloabl_wx_mini_user_info.id){
                //     params.phone = this.$common.gloabl_wx_mini_user_info.phone;
                // }
                return params;
            }
        },

        // watch: {
        //     activeNames(value) {
        //         if (value && value.length > 0) {
        //             this.collapse_righe_icon = '收起';
        //         } else {
        //             this.collapse_righe_icon = '展开';
        //         }
        //     }
        // }
    }
</script>

<style scoped>

</style>